<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.16668 1.19446C2.52517 1.19446 1.19446 2.52517 1.19446 4.16668V11.9445C1.19446 13.586 2.52517 14.9167 4.16668 14.9167H11.9445C13.586 14.9167 14.9167 13.586 14.9167 11.9445V4.16668C14.9167 2.52517 13.586 1.19446 11.9445 1.19446H4.16668ZM2.69446 4.16668C2.69446 3.35359 3.35359 2.69446 4.16668 2.69446H11.9445C12.7575 2.69446 13.4167 3.35359 13.4167 4.16668V11.9445C13.4167 12.7575 12.7575 13.4167 11.9445 13.4167H4.16668C3.35359 13.4167 2.69446 12.7575 2.69446 11.9445V4.16668Z"
            fill="#8E8E93"
        />
        <path
            d="M16.9483 5.29934C16.5644 5.14379 16.1271 5.3289 15.9716 5.7128C15.816 6.0967 16.0011 6.534 16.385 6.68955C16.9263 6.90888 17.3056 7.4383 17.3056 8.05556V15.8333C17.3056 16.6469 16.6469 17.3056 15.8333 17.3056H8.05556C7.43919 17.3056 6.9088 16.9261 6.68955 16.385C6.534 16.0011 6.0967 15.816 5.7128 15.9716C5.3289 16.1271 5.14379 16.5644 5.29934 16.9483C5.74009 18.0361 6.80748 18.8056 8.05556 18.8056H15.8333C17.4753 18.8056 18.8056 17.4753 18.8056 15.8333V8.05556C18.8056 6.80615 18.0359 5.74001 16.9483 5.29934Z"
            fill="#8E8E93"
        />
    </svg>
</template>
